module.exports = __webpack_public_path__ + "img/sozialschnellgut_5_b.9fa4669f.jpg";